const createFormErrors = (errors = []) =>
  errors.reduce(
    (acc, error) => ({ ...acc, [error.source?.pointer ?? "/"]: error.title }),
    {}
  );

export default createFormErrors;
